import { Identifier } from 'react-admin'
import { useQuery } from 'react-query'
import { CacheKeys } from 'shared/helpers/cacheKeys'

import { fetchUser } from '../api/core'
import { User } from '../models/user'

export function useUser(id: Identifier, { enabled = true } = {}) {
  const { data, isLoading, refetch } = useQuery(`${CacheKeys.USER}-detail-${id}`, () => fetchUser(id), {
    enabled: Boolean(id) && enabled,
    refetchOnWindowFocus: false,
    retry: true,
    retryDelay: (attempt) => Math.min(attempt > 1 ? 2 ** attempt * 1000 : 1000, 30 * 1000),
  })

  return {
    user: data as User | null,
    isLoading,
    refetch,
  }
}
